export const messages = {
  en: {
    upShopHouseManage: {
      queryCondition: 'Query Conditions',
      inputApplicant: 'Input applicant',
      inputOrderNo: 'Input order number',
      selectStatus: 'Select status',
      purchaseOrder: 'Purchase Order',
      applyPurchase: 'Apply Purchase',
      orderNo: 'Order No',
      goods: 'Goods',
      status: 'Status',
      applicant: 'Applicant',
      applyTime: 'Apply Time',
      remark: 'Remark'
    },
    deleteInoutOrder: {
      confirmTitle: 'Confirm Operation',
      confirmText: 'Confirm to delete this order?'
    },
    audit: {
      auditInfo: 'Audit Information',
      auditStatus: 'Audit Status',
      selectAuditStatus: 'Select audit status',
      agree: 'Agree',
      reject: 'Reject',
      reason: 'Reason',
      inputReason: 'Please input reason'
    }
  },
  zh: {
    upShopHouseManage: {
      queryCondition: '查询条件',
      inputApplicant: '请输入申请人',
      inputOrderNo: '请输入单号',
      selectStatus: '请选择状态',
      purchaseOrder: '进货单',
      applyPurchase: '申请进货',
      orderNo: '单号',
      goods: '商品',
      status: '状态',
      applicant: '申请人',
      applyTime: '申请时间',
      remark: '备注'
    },
    deleteInoutOrder: {
      confirmTitle: '请确认您的操作',
      confirmText: '确定删除订单'
    },
    audit: {
      auditInfo: '审核信息',
      auditStatus: '审核状态',
      selectAuditStatus: '请审核',
      agree: '同意',
      reject: '拒绝',
      reason: '原因',
      inputReason: '必填，请填写原因'
    }
  }
}